import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import store from './layouts/Main/store';
import { createBrowserHistory } from 'history';
import { Router } from 'react-router-dom';
//import "./index.css"

const browserHistory = createBrowserHistory();
//redux
// ReactDOM.render(
//   <React.StrictMode>
//     <Provider store={store}>
//       <App />
//     </Provider> 
//   </React.StrictMode>,
//   document.getElementById('root')
// );
ReactDOM.render((
  <Provider store={store}>
     <Router history={browserHistory}>
        <App />
     </Router>

  </Provider>
), document.getElementById('root'));

serviceWorker.unregister();
